import { render, staticRenderFns } from "./update-member-data-config.vue?vue&type=template&id=983535ce"
import script from "./update-member-data-config.vue?vue&type=script&lang=ts"
export * from "./update-member-data-config.vue?vue&type=script&lang=ts"
import style0 from "./update-member-data-config.vue?vue&type=style&index=0&id=983535ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports